import { StyleSheet } from '@react-pdf/renderer';

export const reportPdfStyles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#fff',
    padding: 30,
    fontSize: 10,
    fontFamily: 'Helvetica',
  },
  header: {
    marginBottom: 20,
    borderBottom: '2 solid #333',
    paddingBottom: 10,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 5,
    color: '#1976d2',
  },
  subtitle: {
    fontSize: 12,
    color: '#666',
    marginBottom: 3,
  },
  dateRange: {
    fontSize: 10,
    color: '#999',
  },
  kpiSection: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 20,
    marginTop: 10,
  },
  kpiCard: {
    width: '23%',
    padding: 10,
    backgroundColor: '#f5f5f5',
    borderRadius: 4,
    border: '1 solid #ddd',
  },
  kpiLabel: {
    fontSize: 9,
    color: '#666',
    marginBottom: 4,
  },
  kpiValue: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#1976d2',
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    marginTop: 15,
    marginBottom: 10,
    color: '#333',
    borderBottom: '1 solid #ddd',
    paddingBottom: 5,
  },
  table: {
    display: 'flex',
    width: 'auto',
    marginBottom: 15,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottom: '1 solid #ddd',
    minHeight: 25,
    alignItems: 'center',
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#1976d2',
    color: '#fff',
    fontWeight: 'bold',
    borderBottom: '2 solid #1565c0',
  },
  tableCell: {
    padding: 5,
    fontSize: 9,
    flex: 1,
  },
  tableCellHeader: {
    padding: 5,
    fontSize: 10,
    fontWeight: 'bold',
    flex: 1,
    color: '#fff',
  },
  footer: {
    position: 'absolute',
    bottom: 20,
    left: 30,
    right: 30,
    textAlign: 'center',
    fontSize: 8,
    color: '#999',
    borderTop: '1 solid #ddd',
    paddingTop: 10,
  },
  pageNumber: {
    fontSize: 8,
    color: '#999',
  },
});
